module.exports = __webpack_public_path__ + "static/img/norank-bg.a32c8f50.png";